<template>
    <div class="container-fluid">
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" v-html="trans[locale].academic_year"></label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_year"
                             :options="selector_year_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="false"
                             :close-on-select="true"
                             :hide-selected="false"
                             :internal-search="true"
                             :searchable="false"
                             :preselect-first="true"
                             :allow-empty="false"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                            :show-labels="false"
                >
                </multiselect>
            </div>
        </div>

        <div class="form-group row" v-if="selector_selected_year != null && typeof selector_selected_year.is_current_year != 'undefined' && selector_selected_year.is_current_year">
            <label class="col-sm-3 col-form-label">{{ trans[locale].account_status }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="active"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_active }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="disable"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_disable }}
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row" v-if="selector_selected_year != null && typeof selector_selected_year.is_current_year != 'undefined' && selector_selected_year.is_current_year">
            <label class="col-sm-3 col-form-label">{{ trans[locale].student_status }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_student_status"
                               value="in_attendance"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].student_status_in_attendance }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_student_status"
                               value="withdrawn"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].student_status_withdrawn }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_student_status"
                               value="graduated"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].student_status_graduated }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_student_status"
                               value="new_student"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].student_status_new_student }}
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].non_chinese_speaking }}</label>
            <div class="col-sm-9">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_non_chinese_speaking_status"
                               value="ncs"
                               :disabled="loading"
                        ><span class="checkmark"></span>
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].language }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="radio"
                               name="language"
                               :disabled="loading"
                               v-model="selector_language_options"
                               value="all"
                        >
                        <span class="checkmark"></span> {{ trans[locale].language_all }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="radio"
                               name="language"
                               :disabled="loading"
                               v-model="selector_language_options"
                               value="chinese"
                        >
                        <span class="checkmark"></span> {{ trans[locale].language_chinese }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="radio"
                               name="language"
                               :disabled="loading"
                               v-model="selector_language_options"
                               value="non_chinese"
                        >
                        <span class="checkmark"></span> {{ trans[locale].language_non_chinese }}
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].student }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_users"
                             :options="selector_user_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="is_multiple"
                             :close-on-select="false"
                             :hide-selected="true"
                             :searchable="true"
                             :internal-search="true"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :limit="limit" :limitText="limitText"
                             :loading="loading"
                             :disabled="loading"
                             :show-labels="false"
                             :show-no-results="false"
                             group-values="libs"
                             group-label="language"
                            :group-select="true"
                >
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../../store/store';
    import UserSelector from './UserSelector';
    export default {
        mixins: [ UserSelector ],
        name: 'SelectorStudent',
        components: { UserSelector },
        store,
        data() {
            return Object.assign(
                {
                    selector_selected_year: null,
                    selector_year_options: [],
                    selector_language_options: 'all',
                    selector_selected_status: [ 'active' ],
                    selector_selected_student_status: [ 'in_attendance' ],
                    selector_selected_non_chinese_speaking_status: []
                }
            )
        },
        watch: {
            selector_selected_year: _.debounce(
                function(newVal) {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_year]', 'gray');
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),
            selector_language_options: _.debounce(
                function(newVal) {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_language_options]', 'gray');
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),
            selector_selected_status: _.debounce(
                function(newVal) {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_status]', 'gray');
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),
            selector_selected_student_status: _.debounce(
                function(newVal) {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_student_status]', 'gray');
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),
            selector_selected_non_chinese_speaking_status: _.debounce(
                function(newVal) {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => WATCH Processing [selector_selected_non_chinese_speaking_status]', 'gray');
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),
        },
        methods: {
            initialSelector() {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [initialSelector]', 'gray');
                this.getYearOptions();
            },
            getYearOptions() {
                let self = this;
                let url = '/api/options/get-year?without_future=y';
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getYearOptions] => ' + url, 'gray');
                let method = 'get';
                let successCallBack = (response) => {
                    self.selector_year_options = response.data;
                    self.selector_selected_year = _.first(self.selector_year_options);
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getYearOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getYearOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },
            getUserOptions: _.debounce(function(){
                if (!_.isNull(self.selector_selected_year))
                {
                    let self = this;
                    let ignored_users = [];
                    let url = "/api/options/get-student/_ALL_/";

                    let selected_users_ids = [];
                    _.forEach(self.selector_selected_users, (item) => {
                        selected_users_ids.push(item.key);
                    });
                    // url = url + _.join(selected_users_ids, this.array_delimiter);

                    let ignored_users_ids = [];
                    _.forEach(self.selector_ignored_users, (item) => {
                        ignored_users_ids.push(item.key);
                    });

                    let is_current_year = !_.isNull(self.selector_selected_year) &&
                        !_.isUndefined(self.selector_selected_year.is_current_year) &&
                        self.selector_selected_year.is_current_year;

                    let req_param = {
                        extra: 'with_group',
                        req_key: this.request_type,
                        selected_users: selected_users_ids,
                        ignored_users: ignored_users_ids,
                        year: self.selector_selected_year.key,
                        language: self.selector_language_options,
                        account_status: is_current_year && _.size(self.selector_selected_status) > 0 ? self.selector_selected_status : null,
                        student_status: is_current_year && _.size(self.selector_selected_student_status) > 0 ? self.selector_selected_student_status : null,
                        non_chinese_speaking_status: _.size(self.selector_selected_non_chinese_speaking_status) > 0 ? self.selector_selected_non_chinese_speaking_status : null,
                        filter_state: 'standby',
                    };

                    // url = url + '?' + $.param(req_param);
                    let formData = req_param;
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getUserOptions] => ' + url, 'gray');
                    let method = 'post';

                    let successCallBack = (response) => {
                        self.selector_user_options = response.data;
                        if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getUserOptions]', 'success');
                        if (_.isUndefined(response.data[0].libs)) {
                            if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                        } else {
                            if (this.is_debug) this.debugMessage(' Total Options: ' + _.size(response.data[0].libs), 'success');
                        }
                    };
                    let failedCallBack = (error) => {
                        if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getUserOptions]', 'error');
                        if (this.is_debug) this.debugMessage(error, 'error');
                        if (error.response.status == '422') {
                            this.$store.commit('setValidationError', error.toString())
                        } else {
                            this.$store.commit('setError', error.toString())
                        }
                    };
                    this.postOptions(url, method, formData, successCallBack, failedCallBack);
                }
            }, store.getters.debounceMS),
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/SelectorStudent.vue